export default __webpack_public_path__ + "static/reward-5-facbfa09c9d9a346f4f98d104744571e.png";